export default [
  { name: 'Carlow', code: 'CW' },
  { name: 'Cavan', code: 'CN' },
  { name: 'Clare', code: 'CE' },
  { name: 'Cork', code: 'CO' },
  { name: 'Donegal', code: 'DL' },
  { name: 'Dublin', code: 'D' },
  { name: 'Galway', code: 'G' },
  { name: 'Kerry', code: 'KY' },
  { name: 'Kildare', code: 'KE' },
  { name: 'Kilkenny', code: 'KK' },
  { name: 'Laois', code: 'LS' },
  { name: 'Leitrim', code: 'LM' },
  { name: 'Limerick', code: 'LK' },
  { name: 'Longford', code: 'LD' },
  { name: 'Louth', code: 'LH' },
  { name: 'Mayo', code: 'MO' },
  { name: 'Meath', code: 'MH' },
  { name: 'Monaghan', code: 'MN' },
  { name: 'Offaly', code: 'OY' },
  { name: 'Roscommon', code: 'RN' },
  { name: 'Sligo', code: 'SO' },
  { name: 'Tipperary', code: 'TA' },
  { name: 'Waterford', code: 'WD' },
  { name: 'Westmeath', code: 'WH' },
  { name: 'Wexford', code: 'WX' },
  { name: 'Wicklow', code: 'WW' }
];
